import { useCallback, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";

import { toast } from "react-hot-toast";
import Agent from "../../Network/Agent";
import { RMS_ALARM_HISTORY_FETCH_START } from "../../Reducer/RmsAlarmHistorySlice";
import { RMS_ALARM_TYPE_FETCH_SUCCESS } from "../../Reducer/RmsAlarmTypeSlice";
import API from "../../Network/API";
import { AlarmNav } from "../../CustomMemo/AlarmNav";
import CountdownTimer from "../../Props/CountdownTimer";
import RmsAlarmFilter from "./RmsAlarmFilter";
import NProgress from 'nprogress';

export default function RmsAlarm() {

  const [alarm_type, setAlarmType] = useState([])
  const [alarm_type_data, setAlarmTypeData] = useState([])
  const [site_code, setSiteCode] = useState([])
  const [site_id, setSiteId] = useState('')
  const [start_date, setStartDate] = useState('')
  const [end_date, setEndDate] = useState('')
  const [export_data, setExportData] = useState([])
  const [loading_export, setLoadingExport] = useState(false)
  const [loading, setLoading] = useState(true);
  const observer = useRef();
  const [page, setPage] = useState(1);

  // Defensive setter for page
  const safeSetPage = (pg) => {
    const nextPage = (typeof pg === 'number' && !isNaN(pg) && pg > 0) ? pg : 1;
    setPage(nextPage);
  };

  const ref_input = useRef(null);
  const inputRef = useRef(null);
  const inputStartDate = useRef(null);
  const inputEndDate = useRef(null);
  const dispatch = useDispatch();
  const [searchParam, setSearchParams] = useSearchParams();
  const selector_lock_type = useSelector((state) => state.rmsAlarmTypeReducer);
  const searchParams = new URLSearchParams(window.location.search);
  var chec = document.querySelector('.rms_type_' + searchParams.get('type'));
  const type = parseInt(searchParams.get('type'));
  const selector_rms_alarm_nav = useSelector((state) => state.rmsAlarmGroupReducer)
  const selector_rms_alarms = useSelector((state) => state.rmsAlarmHistoryReducer)

  const array_data = useRef({
    'page': 1,
    'site_code': "",
    'tenant_id': "",
    'cluster': "",
    'zone': "",
    'alarm_type': "",
    'start_date': "",
    'end_date': "",
    'filter_type': "",
    'query': "",
    'loadMore': false,
  });



  useEffect(() => {

    Agent.RMS_ALARM.nav(dispatch);
    if (type > 0) {
      if (alarm_type.indexOf(type) === -1) {
        const checkk = document.querySelector('.rms_type_' + type);

        if (checkk) {
          checkk.click();
        }

        setAlarmType([...alarm_type, type]);
        dispatch(RMS_ALARM_TYPE_FETCH_SUCCESS(type));

        const checs = document.querySelector('.rms_type_' + type);
        setAlarmTypeData([...alarm_type_data, {
          'id': type,
          'name': checs?.title,
        }]);
      }
    }

  }, []);


  const refClick = () => {

    if (type > 0) {
      const checkk = document.querySelector('.rms_type_' + type);
      if (checkk) {
        checkk.checked = true;
      }

      if (alarm_type.includes(type) === -1) {
        setAlarmType([...alarm_type, type]);
        dispatch(RMS_ALARM_TYPE_FETCH_SUCCESS(type));
      }

      // if (alarm_type_data.every(item => item.id !== type)) {
      //   setAlarmTypeData([...alarm_type_data, {
      //     'id': type,
      //     'name': checkk?.title,
      //   }]);
      // }

      const updatedData = [...alarm_type_data];

      const index = updatedData.findIndex(item => item.id === type);

      if (index !== -1) {
        updatedData[index] = {
          id: type,
          name: checkk?.title,
        };
      } else {
        updatedData.push({
          id: type,
          name: checkk?.title,
        });

      }

      setAlarmTypeData(updatedData);

    }
  }


  const alarmTypeSelect = (event) => {
    if (event.target.checked) {
      if (alarm_type.indexOf(parseInt(event.target.value)) === -1) {
        setAlarmType([
          ...alarm_type, parseInt(event.target.value)
        ])

        dispatch(RMS_ALARM_TYPE_FETCH_SUCCESS(parseInt(event.target.value)))
        setAlarmTypeData([...alarm_type_data, {
          'id': parseInt(event.target.value),
          'name': event.target.title,
        }])
        setPage(1);
        array_data.current.page = 1;
        array_data.current.loadMore = false;
        // Agent.RMS_ALARM.rms_alarm_history_new(dispatch, array_data?.current)
      }

    } else {
      dispatch(RMS_ALARM_TYPE_FETCH_SUCCESS(parseInt(event.target.value)))
      removeID(parseInt(event.target.value))
      removeType(parseInt(event.target.value))

    }

  }



  useEffect(() => {


    if (searchParam.get("tenant_id")) {
      array_data.current.tenant_id = searchParam.get("tenant_id");
    }
    
    array_data.current.query = alarm_type;
    array_data.current.site_code = site_id;
    if (page != 1) {
      array_data.current.page = page;
      array_data.current.loadMore = true;
    }
    dispatch(RMS_ALARM_HISTORY_FETCH_START());

    Agent.RMS_ALARM.rms_alarm_history_new(dispatch, array_data?.current)

  }, [selector_lock_type.data, page]);


  const removeType = (u_id) => {
    setAlarmTypeData(alarm_type_data.filter(a =>
      a.id !== u_id
    ))
    removeID(u_id)
  }

  const removeID = (url) => {
    const index = alarm_type.indexOf(url);
    if (index > -1) { // only splice array when item is found
      alarm_type.splice(index, 1); // 2nd parameter means remove one item only
    }
    setAlarmType(alarm_type)
    array_data.current.query = alarm_type;
    array_data.current.site_code = site_id;
    setPage(1);
    array_data.current.page = 1;
    array_data.current.loadMore = false;
    Agent.RMS_ALARM.rms_alarm_history_new(dispatch, array_data?.current)
  }

  const checkedState = (id) => {
    return alarm_type.find((element) => {
      return element === id;
    })

  }


  const clearFiler = () => {
    setPage(1);
    setAlarmType([]);
    setAlarmTypeData([]);
    setSiteCode([]);
    setSiteId("");
    setStartDate('');
    setEndDate('');
    // inputRef.current.value = "";
    // inputEndDate.current.value = "";
    // inputStartDate.current.value = "";

    var textinputs = document.querySelectorAll('input:checked');
    var empty = [].filter.call(textinputs, function (el) {
      el.checked = false;
    });

    window.history.replaceState(null, '', '/rms_alarms');
    array_data.current.site_code = '';
    array_data.current.cluster = '';
    array_data.current.zone = '';
    array_data.current.alarm_type = '';
    array_data.current.filter_type = '';
    array_data.current.tenant_id = '';
    array_data.current.start_date = '';
    array_data.current.end_date = '';
    array_data.current.page = 1;
    setPage(1);
    array_data.current.loadMore = false;
    Agent.RMS_ALARM.rms_alarm_history_new(dispatch, array_data?.current)


  }

  const refreshFiler = () => {
    refClick()
    array_data.current.query = alarm_type;
    array_data.current.site_code = site_id;
    setPage(1);
    array_data.current.page = 1;
    array_data.current.loadMore = false;
    Agent.RMS_ALARM.rms_alarm_history_new(dispatch, array_data?.current)
  }

  const searchSite = (site_id) => {
    setSiteId(site_id);
    array_data.current.query = alarm_type;
    array_data.current.site_code = site_id;
    setPage(1);
    array_data.current.page = 1;
    array_data.current.loadMore = false;
    Agent.RMS_ALARM.rms_alarm_history_new(dispatch, array_data?.current)
  }




  async function downloadAlarmReport(params) {
    try {
      setLoadingExport(true)
      if (array_data.current.start_date == '' && array_data.current.end_date == '') {
        toast.error('Please select date')
        setLoadingExport(false)
        return false;
      }
      const response = await API.get(`/v1/oauth/export_rms_alarm?query=${encodeURIComponent(alarm_type)}&site_id=${array_data?.current.site_code}&start_date=${array_data.current.start_date}&end_date=${array_data.current.end_date}&tenant_id=${array_data?.current.tenant_id}&alarm_type=${array_data?.current.alarm_type}&filter_type=${array_data?.current.filter_type}&cluster=${array_data?.current.cluster}&zone=${array_data?.current.zone}`, {
        params,
        responseType: 'blob',
      });
      // Extract filename from Content-Disposition header or set a default
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'rms_active_alarms.xlsx'; // Default filename

      if (contentDisposition) {
        const matches = /filename[^;=\n]*=(['"]?)([^'";\n]*)\1/.exec(contentDisposition);
        if (matches && matches[2]) {
          filename = matches[2];
        }
      }

      // Create download link and trigger download
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(new Blob([response.data]));
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up the download link to avoid memory leaks
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadLink.href);
    } catch (error) {
      console.error('Error exporting file:', error);
    } finally {
      setLoadingExport(false);
    }
  }


  function FormattedNumber(number = 0) {

    const formatted = number.toLocaleString(); // or Intl.NumberFormat().format(number)

    return formatted;
  }


  const lastElementRef = useCallback((element) => {
    //element is the react element being referenced

    // disconnect observer set on previous last element
    if (observer.current) observer.current.disconnect();

    // if there's no more data to be fetched, don't set new observer
    if (!selector_rms_alarms?.data.has_more_page) return;

    // set new observer
    observer.current = new IntersectionObserver((entries) => {
      // increase page number when element enters (is intersecting with) viewport.
      // This triggers the pagination hook to fetch more items in the new page
      if (entries[0].isIntersecting && selector_rms_alarms?.data.has_more_page) setPage((prev) => prev + 1);
    });

    // observe/monitor last element
    if (element) observer.current.observe(element);
  }, [selector_rms_alarms?.data.has_more_page]);


  const copyToClipboard = (s_data) => {
    // Manually construct the text with line breaks between fields
    const formattedText = `
              Site ID: ${s_data.site_id}
              Operator Site ID: ${s_data.easi_site_id}
              Tenant: ${s_data.tenant_name}
              Alarm Name: ${s_data.name}
              Alarm Time: ${s_data.alarm_start}
            `;

    // Create a temporary textarea element to copy the formatted text
    const textArea = document.createElement('textarea');
    textArea.value = formattedText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    alert('Copied to clipboard!');
  };

  const callbackSearch = (searchData) => {
    console.log(searchData);
    array_data.current.page = 1;
    array_data.current.loadMore = false;
    array_data.current.query = '';
    array_data.current.site_code = searchData?.site_code;
    array_data.current.start_date = searchData?.start_date;
    array_data.current.end_date = searchData?.end_date;
    array_data.current.tenant_id = searchData?.tenant_id;
    array_data.current.alarm_type = searchData?.alarm_type;
    array_data.current.cluster = searchData?.cluster;
    array_data.current.zone = searchData?.zone;
    array_data.current.filter_type = searchData?.filter_type;
    setPage(1);
    dispatch(RMS_ALARM_HISTORY_FETCH_START())
    Agent.RMS_ALARM.rms_alarm_history_new(dispatch, array_data?.current)

  }

  return (
    <>
      <div className="d-flex justify-content-between">
        <ul className="" >
        </ul>
        <div className="mt-2">
          <div class="input-group input-group-sm">
            <input ref={inputRef} onKeyUp={(e) => searchSite(e.target.value)} type="text" class="form-control" placeholder="search by site id...." defaultValue={site_id} />
            {/* <input ref={inputStartDate} onChange={(e) => setStartDate(e.target.value)} type="date" class="form-control" placeholder="" defaultValue={start_date} />
            <input ref={inputEndDate} onChange={(e) => setEndDate(e.target.value)} type="date" class="form-control" placeholder="" defaultValue={end_date} />
            <button onClick={() => searchFiler()} class="btn btn-info btn-search" type="button"><i class="fa-solid fa-search" /> Search</button> */}
            <RmsAlarmFilter callbackSearch={callbackSearch} />
            <button class="btn btn-success" type="button" onClick={() => downloadAlarmReport()}> <i class="fa-duotone fa-download" /> Export {loading_export ? (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <span></span>
            )}</button>
            <button class="btn btn-warning" type="button" onClick={() => refreshFiler()}><i class="fa-light fa-refresh" /> Sync</button>
            <button class="btn btn-danger" type="button" onClick={() => clearFiler()}><i class="fa-light fa-remove" /> Clear</button>

          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-2">
          <div className="scroll-side-nav">
            {!selector_rms_alarm_nav?.loading && selector_rms_alarm_nav?.data?.rms_alarm_group?.map((rms_alarm, index) => (
              <>
                <ul className="list-group alarm-list mb-2 ">
                  <li className=" list-group-item d-flex justify-content-between align-items-center align-items-center title text-white">
                    <h6 className="m-0 p-0  text-white">{rms_alarm.name}</h6>
                  </li>
                  {rms_alarm?.alarm?.map((alarm, index) => (
                    <AlarmNav ref={ref_input} checkedState={checkedState} alarmTypeSelect={alarmTypeSelect} id={alarm.order_list} title={alarm.name} value={alarm.active_alarm_count} />
                  ))}
                </ul>
              </>
            ))}
          </div>
        </div>

        <div className="col-md-10 col-sm-12">
          <div class="row mb-1 mt-1"><div class="d-flex justify-items-center justify-content-between">
            <div class="page-title-right">
              {alarm_type.length > 0 ?
                alarm_type_data?.map((typeName, i) =>
                  <span class="badge bg-white shadow-sm rounded-pill text-dark" key={i}>{typeName['name']}  <i class="me-1 fas fa-times-circle" onClick={() => removeType(typeName['id'])}></i></span>
                ) : <span class="badge bg-white shadow-sm rounded-pill text-dark">All  <i class="me-1 fas fa-times-circle"></i></span>}
            </div>

          </div>
          </div>

          <div className="table-responsive custom-table-responsive scroll-side-nav">
            {selector_rms_alarms?.loading && <div className="text-center">Loading......</div>}
            <table className="table custom-table text-center ">
              <tbody>

                {selector_rms_alarms?.alarms.length > 0 && selector_rms_alarms?.alarms?.map((alarm, index) => (

                  <>
                    <tr className="bg-white" ref={index === selector_rms_alarms?.alarms.length - 1 ? lastElementRef : undefined}>
                      <td>
                        <i onClick={() => copyToClipboard(alarm)} className="fa fa-copy text-success" style={{ fontSize: '20px', cursor: 'pointer' }} />

                      </td>
                      <td width="7%">
                        <div className="signal-bars mt1 sizing-box good four-bars">
                          <span>
                            <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                          </span>
                          <div className={`first-bar bar ${alarm.network >= 1 ? '' : 'null-color'}`}>
                          </div>
                          <div className={`second-bar bar ${alarm.network >= 2 ? '' : 'null-color'}`}>
                          </div>
                          <div className={`third-bar bar ${alarm.network >= 3 ? '' : 'null-color'}`}>
                          </div>
                          <div className={`fourth-bar bar ${alarm.network >= 4 ? '' : 'null-color'}`}>
                          </div>
                          <div className={`fifth-bar bar ${alarm.network >= 5 ? '' : 'null-color'}`}>
                          </div>
                        </div>
                      </td>
                      <td width="7%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                        <p className="tr-header">Cluster</p>
                        <p className="tr-header-sub ">{alarm.cluster_name}
                        </p>
                      </td>
                      <td width="7%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                        <p className="tr-header">Zone</p>
                        <p className="tr-header-sub ">{alarm.zone_name}
                        </p>
                      </td>
                      <td width="8%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                        <p className="tr-header">SITE ID</p>
                        <p className="tr-header-sub fw-bold"><Link to={`/site/${alarm.site_id}`}>{alarm.site_id}</Link>
                        </p>
                      </td>
                      <td width="12%">
                        <p className="tr-header">Tenant</p>
                        <p className="tr-header-sub">{alarm.tenant_name}</p>
                      </td>
                      <td width="10%" >
                        <p className="tr-header">Operator Site</p>
                        <p className="tr-header-sub fw-bold"><Link className={`${alarm?.tenant_name == 'Robi' ? 'text-danger' : (alarm?.tenant_name == 'GP' ? 'text-info' : 'text-bl')}`} to={`/site/${alarm.site_id}`}>{alarm.tenant_site_id}</Link></p>
                      </td>
                      <td width="25%">
                        <p className="tr-header">Alarm Name</p>
                        <p className="tr-header-sub">
                          {alarm.name}
                        </p>
                      </td>
                      <td width="15%">
                        <p className="tr-header">Alarm Start</p>
                        <p className="tr-header-date">
                          {alarm.alarm_start}

                        </p>
                      </td>
                      <td width="15%">
                        <p className="tr-header">Alarm End</p>
                        <p className="tr-header-date">
                          {alarm.alarm_end ?? '--'}
                        </p>
                      </td>
                      <td width="20%" className="elisp_time">
                        <p className="tr-header">Elapsed Time</p>
                        <p className="tr-header-sub elisp_time">
                          {alarm.alarm_end != null ?
                            <span className="elisp_time">{alarm.total_elaspsed}</span>
                            :
                            <CountdownTimer targetDate={alarm.start} />
                          }


                        </p>
                      </td>
                    </tr>
                    <tr className="spacer"><td colSpan={100} /></tr>
                  </>

                ))}
              </tbody>
            </table>

            {selector_rms_alarms?.loading && <div className="text-center">Loading......</div>}

          </div>
          <p className="p-0 m-0 fs-12">Current Display 1 - {selector_rms_alarms?.alarms?.length} Record(s), {FormattedNumber(selector_rms_alarms?.data?.total_page)} Record(s) Totally</p>

        </div>
      </div>
    </>
  )
}